import type { WebViewerInstance } from '@pdftron/webviewer';
import { useEffect } from 'react';

import { useCreateRuleActionData } from 'modules/viewerPage/apps/quotePartViewerApps/reqsReview/components/findingsActions';

import { createRuleButton } from '../consts';

type TextPopupButtonProps = {
  instance: WebViewerInstance | null;
};

export const useTextPopupButton = ({ instance }: TextPopupButtonProps) => {
  const { canCreateRule, createRuleAction } = useCreateRuleActionData();

  useEffect(() => {
    if (!canCreateRule || !instance) return;

    const { UI } = instance;

    const existingItems = UI.textPopup.getItems();
    const buttonExists = existingItems.some(
      (item: any) => item.dataElement === 'customTextAction',
    );

    if (!buttonExists) {
      UI.textPopup.add(
        [
          {
            type: 'actionButton',
            img: createRuleButton,
            title: 'Create Rule',
            onClick: () => {
              const selectedText =
                instance.Core.documentViewer.getSelectedText();
              if (selectedText?.trim()) {
                createRuleAction({
                  rawCallout: null,
                  selectedText: selectedText.trim(),
                });
              }
            },
            dataElement: 'customTextAction',
          },
        ],
        'linkButton',
      );
    }
  }, [instance, canCreateRule, createRuleAction]);
};
